export const ALLOWED_CHARACTERS = ["X", "x", " "];
